import { render, staticRenderFns } from "./shck.vue?vue&type=template&id=5e3c5ee8&scoped=true&"
import script from "./shck.vue?vue&type=script&lang=js&"
export * from "./shck.vue?vue&type=script&lang=js&"
import style0 from "./shck.vue?vue&type=style&index=0&id=5e3c5ee8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e3c5ee8",
  null
  
)

export default component.exports